{
  "generic": {
    "no": "Non",
    "yes": "Oui",
    "text": "Texte "
  },
  "consent": {
    "defaultLabelText": "En soumettant ce formulaire, vous acceptez notre ",
    "defaultLabelLink": "politique de confidentialité"
  },
  "text": {
    "defaultHeadlineText": "Ceci est un titre",
    "defaultText": "Ceci est un bloc de texte",
    "floatingDefaultText": "NOUVEAU !"
  },
  "button": {
    "submitDefaultText": "Envoyer",
    "instagramDefaultText": "Suivez-nous",
    "defaultText": "Cliquez ici",
    "closing": "FERMETURE..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Entrez votre e-mail",
    "passwordLabel": "Mot de passe",
    "passwordPlaceholder": "Entrez le mot de passe",
    "nameLabel": "Nom",
    "namePlaceholder": "Entrez votre nom",
    "firstNameLabel": "Prénom",
    "firstNamePlaceholder": "Entrez le prénom",
    "lastNameLabel": "Nom de famille",
    "lastNamePlaceholder": "Entrez le nom de famille",
    "phoneLabel": "Téléphone",
    "phonePlaceholder": "Entrez le numéro de téléphone",
    "textareaLabel": "Message",
    "textareaPlaceholder": "Entrez votre message",
    "regularLabel": "Texte",
    "regularPlaceholder": "Entrez le texte",
    "defaultLabel": "Étiquette",
    "defaultPlaceholder": "Espace réservé",
    "datePlaceholder": "Sélectionnez la date",
    "stepLabel": "Entrez votre question ici"
  },
  "dropdown": {
    "placeholder": "Sélectionnez une option",
    "firstItem": "Option 1",
    "secondItem": "Option 2",
    "chooseCountry": "Pays"
  },
  "buttonList": {
    "firstItem": "Option 1",
    "secondItem": "Option 2",
    "option1": "Choix 1",
    "option2": "Choix 2",
    "option3": "Choix 3",
    "subscriptionItem1": "Lettre d'information",
    "subscriptionItem2": "Mises à jour",
    "chooseSubscriptionTopics": "Choisir les sujets d'abonnement",
    "other": "Autre",
    "uncheck-all-label": "Je ne souhaite recevoir aucun de ces e-mails"
  },
  "rating": {
    "rateLabel": "Évaluez-nous",
    "npsLabel": "Quelle est la probabilité que vous nous recommandiez ?",
    "veryUnsatisfied": "Très insatisfait",
    "unsatisfied": "Insatisfait",
    "neutral": "Neutre",
    "satisfied": "Satisfait",
    "loveIt": "J'adore !",
    "minValueLabel": "Faible",
    "maxValueLabel": "Élevé",
    "minValueLabelNps": "Peu probable",
    "maxValueLabelNps": "Très probable"
  },
  "deadline": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes"
  },
  "bulletList": {
    "firstItem": "Avantage 1",
    "secondItem": "Avantage 2"
  },
  "discountCode": {
    "copyMessage": "Copié dans le presse-papiers !",
    "fallback": "WELCOME10",
    "textDefault": "Votre code de réduction",
    "buttonDefault": "Copier"
  },
  "share": {
    "buttonText": "Partager"
  },
  "common": {
    "label": "Étiquette"
  },
  "wcag": {
    "banner": "Bannière promotionnelle",
    "closeButton": "Fermer",
    "submitButton": "Envoyer le formulaire"
  },
  "spinTheWheel": {
    "prizeWonText": "Félicitations !",
    "prizeWonButtonText": "Réclamez votre prix",
    "prizeLostText": "Ahhh, dommage ! :-(",
    "prizeLostButtonText": "Cliquez pour fermer",
    "spinButtonLabel": "TOURNER"
  },
  "memory": {
    "resultWonText": "Bon travail ! Votre temps était {elapsedTime}",
    "resultWonButtonText": "Réclamez votre prix"
  },
  "stepNavigation": {
    "nextButtonText": "Suivant",
    "previousButtonText": "Précédent",
    "lastButtonText": "Fermer",
    "submitButtonText": "Envoyer"
  },
  "defaultRealTimeMessage": {
    "validationError": "Veuillez vérifier le format des données envoyées.",
    "unknownError": "Un problème inattendu s'est produit lors de la soumission.",
    "conflictError": "Cet utilisateur existe déjà.",
    "success": "Formulaire soumis."
  }
}
